/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Subject_Politics_Economics24Inputs */

const en__field_enum_subject_politics_economics24 = /** @type {(inputs: _Field_Enum_Subject_Politics_Economics24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politics & Economics`)
};

const de__field_enum_subject_politics_economics24 = /** @type {(inputs: _Field_Enum_Subject_Politics_Economics24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politik & Wirtschaft`)
};

/**
* | output |
* | --- |
* | "Politics & Economics" |
*
* @param {_Field_Enum_Subject_Politics_Economics24Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_subject_politics_economics24 = /** @type {((inputs?: _Field_Enum_Subject_Politics_Economics24Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Subject_Politics_Economics24Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_subject_politics_economics24(inputs)
	return de__field_enum_subject_politics_economics24(inputs)
});
export { _field_enum_subject_politics_economics24 as "_field_enum_SUBJECT_POLITICS_ECONOMICS" }